import $ from 'jquery'
import 'slick-carousel'

const $doc = $(document)

function pasteBios(n) {
  const count = $('.team__member').length;
  $('.team__member:nth-child('+n+'n)').after('<div class="team__bio-container grid__column is-active"></div>');
    if( !count % 2 === 0 ) {
      $('.team__member:last-child').after('<div class="team__bio-container grid__column is-active"></div>');
    }
}

function addTeamBios() {
  if ($(window).width() < 510) {
    return
  } else if ($(window).width() < 772) {
    pasteBios(2);
  } else if ($(window).width() < 960) {
    pasteBios(3);
  } else {
    pasteBios(4);
  }
}

let width = $(window).width(); 
$(window).on('resize', function() {
  if ($(window).width() == width) return;
  width = $(window).width();
  $('.team__bio-container').remove();
  $('.team__member').removeClass('is-active');
  $('.team__bio-popup').slideUp();
  addTeamBios();
});

function openTeamBio(e) {
  const teamMember = $(this).parent().parent('.team__member');
  const button = teamMember.find('.team__button');
  const memberBio = teamMember.find('.team__bio-popup');
  const bioContainer = teamMember.nextAll('.team__bio-container:first');
  const isDesktop = $(window).width() >= 570;
  const isNotActive = !teamMember.hasClass('is-active');

  $('.team__button').not(button).attr('aria-expanded', 'false');
  if ( teamMember.hasClass('is-active') ) {
    button.attr('aria-expanded', 'false');
  } else {
    button.attr('aria-expanded', 'true');
  }

  $('.team__bio-container').each(function() {
    if ( $(this).hasClass('is-open') && $(this)[0] !== bioContainer[0] ) {
      $(this).hide()
      //$(this).removeClass('is-open')
    }
  });

  !isNotActive && bioContainer.slideUp();
  $('.team__bio-popup').slideUp();
  $('.team__member').removeClass('is-active');
  isNotActive && teamMember.addClass('is-active');
  
  if ( !isDesktop ) {
    isNotActive && memberBio.slideDown({
      duration: 200,
      complete: function(){
        // Store accordion expanded state before scrolling
        const accordions = document.querySelectorAll('[data-team-accordion]');
        const accordionStates = Array.from(accordions).map(accordion => {
          const btn = accordion.parentElement.querySelector('.team__see-more-btn');
          return {
            accordion,
            wasExpanded: btn && btn.getAttribute('aria-expanded') === 'true'
          };
        });

        // Signal accordion system that we're starting external scroll
        if (window.teamAccordionScrollFlag) {
          window.teamAccordionScrollFlag.setScrolling(true);
        }

        // Perform scroll
        $('html, body').animate({
          scrollTop: teamMember.offset().top
        }, {
          duration: 500,
          complete: function() {
            // Signal accordion system that scroll is complete
            if (window.teamAccordionScrollFlag) {
              window.teamAccordionScrollFlag.setScrolling(false);
            }
            
            // Restore accordion states after scroll completes
            setTimeout(() => {
              accordionStates.forEach(({ accordion, wasExpanded }) => {
                if (wasExpanded) {
                  const btn = accordion.parentElement.querySelector('.team__see-more-btn');
                  const hiddenMembers = accordion.querySelectorAll('.team__member.team__member--hidden');
                  const seeMoreContainer = accordion.parentElement.querySelector('.js-see-more');
                  const seeMoreText = seeMoreContainer?.querySelector('.js-see-text');

                  if (btn && hiddenMembers.length > 0) {
                    // Restore accordion state without triggering scroll
                    hiddenMembers.forEach(member => {
                      member.classList.add('team__member--expanded');
                    });
                    btn.setAttribute('aria-expanded', 'true');
                    
                    if (seeMoreText) {
                      const isFrench = window.location.pathname.startsWith("/fr/");
                      seeMoreText.textContent = isFrench ? "Voir moins" : "See less";
                    }
                  }
                }
              });
            }, 100); // Small delay to ensure everything is settled
          }
        });
      }
    });
  } else {
    isNotActive && bioContainer.slideDown();    
    bioContainer.hasClass('is-open') ? bioContainer.removeClass('is-open') : bioContainer.addClass('is-open');
    bioContainer.html( memberBio.html() );
  }
}

function closeTeamBio() {
  $('.team__bio-container').slideUp();
  $('.team__member').removeClass('is-active');
}

$(document).ready( addTeamBios )
$doc.on('click', '.js-open-team-bio', openTeamBio )
$doc.on('click', '.js-close-team-bio', closeTeamBio )
$(document).ready( function(){
  $('.team__bio-popup').on('click',function(e){
    e.preventDefault();
 });
});
